import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import store from "./store";
import "./plugins/element.js";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import Icon from "vue2-svg-icon/Icon.vue";
import Header from "./components/layout/Header.vue";
import Breadcrumb from "./components/layout/Breadcrumb.vue";
import Sidebar from "./components/layout/Sidebar.vue";
import Footer from "./components/layout/Footer.vue";
import moment from "moment";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;

// register golobally
Vue.component("icon", Icon);
Vue.component("app-header", Header);
Vue.component("app-breadcrumb", Breadcrumb);
Vue.component("app-sidebar", Sidebar);
Vue.component("app-footer", Footer);

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers["Authorization"] = `Bearer ${store.state.token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      // 900错误码为前端查询页面无需token
      if (error.response.status !== 200 && error.response.status !== 900) {
        // 返回并清除token信息并跳转到登录页面
        store.commit("REMOVE_COUNT");
        router.replace({
          path: "login",
          query: { redirect: router.currentRoute.fullPath }
        });
      }
    }
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);

// 全局路由拦截器
router.beforeEach((to, from, next) => {
  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    const token = sessionStorage.getItem("token"); // 获取本地存储的token
    if (token === "" || token === null) {
      // 通过vuex state获取当前的token是否存
      next("/login");
    } else {
      next();
    }
  } else {
    next();
  }

  // 路由发生改变修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
